import React, { useState, useLayoutEffect } from 'react'
import api from '../api'

import { QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Input, Space, Table, Alert, Typography, message, Statistic, Modal, Tooltip, Tag } from 'antd'

import { ProCard, CheckCard } from '@ant-design/pro-components'

// import Alipay from 'https://i.n2yun.com.cn/cdn/n2_web/20240904/static/media/alipay.fb7960d688e287342a6f.png'
import Wxpay from '../../images/wxpay.png'

const { Title, Text } = Typography

//  表格
const columns = [
    {
        title: '订单号',
        dataIndex: '_id',
        key: '_id',
    },
    {
        title: '交易类型',
        dataIndex: 'name',
        key: 'name',
        render: ((name) => {
            if (name === 'Balance') {
                return (
                    <Tag>余额充值</Tag>
                )
            }
            if (name === 'ros') {
                return (
                    <Tag>购买 NZCos</Tag>
                )
            }
            if (name === 'Ay') {
                return (
                    <Tag>购买 NZadmin</Tag>
                )
            }
        }),
    },
    {
        title: '金额',
        dataIndex: 'total_amount',
        key: 'total_amount',
    },
    {
        title: '状态',
        dataIndex: 'state',
        key: 'state',
        render: ((name) => {
            if (name == '未完成') {
                return (
                    <Tag color='warning' variant='solid'> 未完成</Tag >
                )
            }
            if (name == '完成') {
                return (
                    <Tag color='success' variant='solid'> 完成</Tag >
                )
            }
        }),
    },
    {
        title: '方式',
        dataIndex: 'pay',
        key: 'pay',
        render: ((name) => {
            if (name === '支付宝') {
                return (
                    <Tag color='#108ee9' variant='solid'> 支付宝</Tag >
                )
            }
            if (name === '微信支付') {
                return (
                    <Tag color='#87d068' variant='solid'> 微信支付</Tag >
                )
            }
        }),
    },
    {
        title: '创建时间',
        dataIndex: 'ctime',
        key: 'ctime',
    },
];

//  控制台-余额中心
function Over(props) {
    const [data, setData] = useState({ money: 0, over: [], amount: 0 })
    const [value, setValue] = useState('alipay')
    const [payment, setPayment] = useState(false)
    const [paymentData, setPaymentData] = useState({})

    useLayoutEffect(() => {
        // let name = 'userOverData'
        // if (localStorage.getItem(name)) {
        //     setData(JSON.parse(localStorage.getItem(name)))
        // }

        api.post('/api/v2/pay_v2/alipay', {
            type: 'get_order_logs',
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data
                    // localStorage.setItem(name, JSON.stringify(Data))
                    setData({ ...data, ...Data })
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }, [])

    function onChange(value) {
        setValue(value)
    }

    //  唤醒支付
    function pay() {
        // if (!props.state.user.phone_number) {
        //     message.error('根据用户协议, 你需要绑定手机号才能使用此功能!')
        //     const link = document.createElement('a')
        //     link.href = '/bindingphone'
        //     link.click()
        //     return
        // }

        if (!value || value !== 'alipay') {
            message.error('目前仅支持支付宝, 暂不支持其他的支付方式')
            return
        }

        api.post('/api/v2/pay_v2/alipay', {
            type: 'create_order',
            amount: data.amount,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    const link = document.createElement('a')
                    link.href = res.data.data.data.url
                    link.target = '_blank';  // 关键修改点
                    link.rel = 'noopener noreferrer'; // 安全建议

                    message.success('正在跳转支付宝支付页面, 支付完成后勿关闭页面...')

                    setTimeout(() => {
                        link.click();
                        setPaymentData({ out_trade_no: res.data.data.data.out_trade_no })
                        setPayment(true)
                    }, 1500);
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }

    function vPay() {
        api.post('/api/v2/pay_v2/alipay', {
            type: 'get_order',
            out_trade_no: paymentData.out_trade_no,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    setPayment(false)
                    message.success('检测到已成功支付!')
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }

    return (
        <div>
            {/* <Alert
                message="恢复自助充值"
                description="目前仅支持支付宝渠道支付, 我们会尽快支持微信支付, 如需要使用微信请联系QQ: 198513272"
                showIcon
                style={{ marginBottom: 20 }}
            /> */}
            <Alert
                message="暂停充值"
                description="已暂停使用网站的余额充值功能, 等待我们完成业务调整。"
                type="warning"
                showIcon
                style={{ marginBottom: 20 }}
            />
            <div style={{ minWidth: 300, float: 'left', marginRight: 20 }}>
                <ProCard title={<Text>余额</Text>} style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', maxWidth: 300, marginBottom: 20 }} bordered headerBordered>
                    <Statistic value={data.money} suffix="¥" />
                </ProCard>
                {/* <ProCard title={<Tooltip title="这是在本站通过上架付费资源获得的收入, 可以提交提现申请, 等站务审核处理。">创作余额 <QuestionCircleOutlined /></Tooltip>} style={{ maxWidth: 300, marginBottom: 20 }} bordered headerBordered>
                    <Statistic value={data.money} suffix="¥" />
                </ProCard> */}
                <ProCard title={<Text>充值说明</Text>} style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', maxWidth: 300, marginBottom: 20 }} bordered>
                    充值流程: 选择支付方式, 输入金额, 扫码支付, 实时到账。
                    <br />
                    如果在充值时遇到问题, 请联系站务进行处理。
                    <br />
                    {/* 注意事项: */}
                    {/* <br /> */}
                    进行充值即表明您已知 <a href="/useragreement" target="_blank" rel="noopener noreferrer">《用户协议》</a> 里的内容并遵循。
                </ProCard>
                {/* <ProCard title="积分" style={{ maxWidth: 300, marginBottom: 20 }} bordered headerBordered>
                    <Statistic value={data.money} suffix="" />
                </ProCard>
                <ProCard title="积分说明" style={{ maxWidth: 300 }} bordered>
                    积分可用于在网站进行资源下载与购买等场景, 新用户注册可获得xx积分。
                </ProCard> */}
            </div>

            <ProCard title={<Text>自助充值</Text>} style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', maxWidth: 500, float: 'left' }} bordered headerBordered>
                <CheckCard.Group style={{ width: '100%' }} defaultValue={value} onChange={onChange}>
                    <CheckCard
                        title="支付宝"
                        size='small'
                        cover={
                            <img
                                alt="alipay"
                                src={'https://cdn.n2yun.com.cn/bed/2025/06/16/300_868_白底 .png'}
                                style={{
                                    width: 160,
                                    height: 50
                                }}
                            />
                        }
                        value="alipay"
                        disabled
                    />
                    <CheckCard
                        title="微信支付"
                        size='small'
                        cover={
                            <img
                                alt="wxpay"
                                src={Wxpay}
                                style={{
                                    width: 120,
                                    height: 50
                                }}
                            />
                        }
                        value="wxpay"
                        disabled
                    />
                </CheckCard.Group>
                <Space.Compact
                    style={{
                        width: 200,
                        marginTop: 20
                    }}
                >
                    <Input type='number' placeholder="请输入金额" value={data.amount} onChange={(e) => { setData({ ...data, amount: e.target.value }) }} disabled />
                    <Button type="primary" onClick={pay} disabled>立即充值</Button>
                </Space.Compact>
            </ProCard>


            <props.clear />
            <Title level={4}>充值记录</Title>
            <Table
                columns={columns}
                dataSource={data.over}
                pagination={false}
                style={{
                    marginTop: 20
                }}
            />

            <Modal
                title="支付结果"
                centered
                open={payment}
                onOk={() => vPay()}
                onCancel={() => setPayment(false)}
            >
                已经完成支付? 点击下方确定进行检查支付状态确保该金额及时到账
            </Modal>
        </div>
    )
}

export default Over;